function daysFromNow(delta: number): string {
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return d.toISOString();
}

function unixDaysFromNow(delta: number): number {
  const d = new Date();
  d.setDate(d.getDate() + delta);
  return Math.floor(d.getTime() / 1000);
}

export const mockTenants = {
  data: [
    { id: 'tenant-1', name: 'Przykładowa Firma sp. z o.o.', nip: '5260001246', plan: 'pro', status: 'active', createdAt: daysFromNow(-120), usersCount: 4 },
    { id: 'tenant-2', name: 'Beta Handel sp.j.', nip: '7792308508', plan: 'max', status: 'active', createdAt: daysFromNow(-80), usersCount: 9 },
    { id: 'tenant-3', name: 'Gamma Consulting', nip: '5252248481', plan: 'free', status: 'demo', createdAt: daysFromNow(-14), usersCount: 1 },
    { id: 'tenant-4', name: 'Delta Logistyka sp. z o.o.', nip: '6342805313', plan: 'pro', status: 'suspended', createdAt: daysFromNow(-220), usersCount: 6 },
    { id: 'tenant-5', name: 'Omega Nieruchomości S.A.', nip: '1132876770', plan: 'max', status: 'active', createdAt: daysFromNow(-45), usersCount: 12 },
  ],
};

export function mockTenant(id: string): Record<string, unknown> {
  return mockTenants.data.find((t) => t.id === id) ?? mockTenants.data[0];
}

export const mockPlatformUsers = {
  data: [
    { id: 'usr-1', email: 'jan.kowalski@przykladowa.pl', firstName: 'Jan', lastName: 'Kowalski', tenantName: 'Przykładowa Firma sp. z o.o.', status: 'active', createdAt: daysFromNow(-118) },
    { id: 'usr-2', email: 'anna.nowak@beta.pl', firstName: 'Anna', lastName: 'Nowak', tenantName: 'Beta Handel sp.j.', status: 'active', createdAt: daysFromNow(-77) },
    { id: 'usr-3', email: 'demo@gamma.io', firstName: 'Piotr', lastName: 'Lewandowski', tenantName: 'Gamma Consulting', status: 'active', createdAt: daysFromNow(-13) },
    { id: 'usr-4', email: 'biuro@delta-log.pl', firstName: 'Maria', lastName: 'Wiśniewska', tenantName: 'Delta Logistyka sp. z o.o.', status: 'disabled', createdAt: daysFromNow(-200) },
    { id: 'usr-5', email: 'k.dabrowski@omega.pl', firstName: 'Krzysztof', lastName: 'Dąbrowski', tenantName: 'Omega Nieruchomości S.A.', status: 'active', createdAt: daysFromNow(-44) },
    { id: 'usr-6', email: 'magazyn@omega.pl', firstName: 'Zofia', lastName: 'Kamińska', tenantName: 'Omega Nieruchomości S.A.', status: 'active', createdAt: daysFromNow(-30) },
  ],
};

export const mockAccountants = {
  data: [
    { id: 'acc-1', email: 'ksiegowa@biuro-rachunkowe.pl', first_name: 'Ewa', last_name: 'Kowalczyk', status: 'active', created_at: daysFromNow(-90) },
    { id: 'acc-2', email: 'k.zielinski@biuro-rachunkowe.pl', first_name: 'Krzysztof', last_name: 'Zieliński', status: 'active', created_at: daysFromNow(-40) },
    { id: 'acc-3', email: 'm.szymanska@biuro-rachunkowe.pl', first_name: 'Magdalena', last_name: 'Szymańska', status: 'active', created_at: daysFromNow(-25) },
    { id: 'acc-4', email: 'r.jankowski@biuro-rachunkowe.pl', first_name: 'Robert', last_name: 'Jankowski', status: 'disabled', created_at: daysFromNow(-150) },
  ],
};

export const mockHrStaff = {
  data: [
    { id: 'hr-1', email: 'kadry@biuro-kadr.pl', first_name: 'Agnieszka', last_name: 'Mazur', status: 'active', created_at: daysFromNow(-60) },
    { id: 'hr-2', email: 'placa@biuro-kadr.pl', first_name: 'Tomasz', last_name: 'Wójcik', status: 'disabled', created_at: daysFromNow(-30) },
    { id: 'hr-3', email: 'a.wojciechowska@biuro-kadr.pl', first_name: 'Aleksandra', last_name: 'Wojciechowska', status: 'active', created_at: daysFromNow(-18) },
  ],
};

export const mockPlans = {
  data: [
    { id: 'free', name: 'Darmowy', description: 'Do 5 faktur miesięcznie', priceMonthly: 0, priceYearly: 0, currency: 'PLN', purchasable: true, free: true, invoiceLimit: 5, active: true, aiAccounting: false, fixedAssets: false, tenantsCount: 1 },
    { id: 'pro', name: 'Pro', description: 'Pełne fakturowanie + kadry', priceMonthly: 49, priceYearly: 490, currency: 'PLN', purchasable: true, free: false, invoiceLimit: null, active: true, aiAccounting: false, fixedAssets: true, tenantsCount: 2 },
    { id: 'max', name: 'Max', description: 'Wszystkie moduły + AI', priceMonthly: 99, priceYearly: 990, currency: 'PLN', purchasable: true, free: false, invoiceLimit: null, active: true, aiAccounting: true, fixedAssets: true, tenantsCount: 2 },
  ],
};

export const mockSupportTickets = {
  data: [
    { id: 'tic-1', panel: 'app', companyId: 'tenant-2', companyName: 'Beta Handel sp.j.', createdById: 'usr-2', createdByName: 'Anna Nowak', subject: 'Błąd przy eksporcie JPK_V7', category: 'bug', status: 'open', lastMessage: 'Przy próbie eksportu pojawia się błąd 500.', lastMessageAt: daysFromNow(-1), unreadCount: 2, createdAt: daysFromNow(-2), updatedAt: daysFromNow(-1) },
    { id: 'tic-2', panel: 'accountancy', companyId: 'tenant-1', companyName: 'Przykładowa Firma sp. z o.o.', createdById: 'usr-1', createdByName: 'Jan Kowalski', subject: 'Pytanie o limit faktur w planie Pro', category: 'question', status: 'in_progress', lastMessage: 'Dziękuję, sprawdzę ustawienia planu.', lastMessageAt: daysFromNow(-3), unreadCount: 0, createdAt: daysFromNow(-5), updatedAt: daysFromNow(-3) },
    { id: 'tic-3', panel: 'hr', companyId: 'tenant-4', companyName: 'Delta Logistyka sp. z o.o.', createdById: 'usr-4', createdByName: 'Maria Wiśniewska', subject: 'Nie mogę dodać pracownika', category: 'bug', status: 'waiting', lastMessage: 'Prosimy o zrzut ekranu z komunikatem błędu.', lastMessageAt: daysFromNow(-4), unreadCount: 1, createdAt: daysFromNow(-6), updatedAt: daysFromNow(-4) },
    { id: 'tic-4', panel: 'app', companyId: 'tenant-3', companyName: 'Gamma Consulting', createdById: 'usr-3', createdByName: 'Piotr Lewandowski', subject: 'Prośba o zmianę danych na fakturze', category: 'question', status: 'resolved', lastMessage: 'Dane zostały zaktualizowane, dziękujemy.', lastMessageAt: daysFromNow(-8), unreadCount: 0, createdAt: daysFromNow(-10), updatedAt: daysFromNow(-8) },
    { id: 'tic-5', panel: 'accountancy', companyId: 'tenant-2', companyName: 'Beta Handel sp.j.', createdById: 'usr-2', createdByName: 'Anna Nowak', subject: 'Rozliczenie VAT-7 za poprzedni miesiąc', category: 'question', status: 'closed', lastMessage: 'Sprawa zamknięta.', lastMessageAt: daysFromNow(-20), unreadCount: 0, createdAt: daysFromNow(-24), updatedAt: daysFromNow(-20) },
    { id: 'tic-6', panel: 'hr', companyId: 'tenant-5', companyName: 'Omega Nieruchomości S.A.', createdById: 'usr-5', createdByName: 'Krzysztof Dąbrowski', subject: 'Jak wygenerować PIT-11 dla pracownika?', category: 'question', status: 'open', lastMessage: 'Gdzie znajdę deklarację PIT-11 w panelu Kadry?', lastMessageAt: daysFromNow(0), unreadCount: 3, createdAt: daysFromNow(-1), updatedAt: daysFromNow(0) },
  ],
};

const ticketThreads: Record<string, Array<Record<string, unknown>>> = {
  'tic-1': [
    { id: 'msg-1-1', authorType: 'user', authorId: 'usr-2', authorName: 'Anna Nowak', body: 'Przy próbie eksportu JPK_V7 pojawia się błąd 500. Co robię źle?', createdAt: daysFromNow(-2), mine: false },
    { id: 'msg-1-2', authorType: 'support', authorId: 'master-admin-1', authorName: 'Wsparcie Księgowskaz', body: 'Dzień dobry, sprawdzamy zgłoszenie. Czy błąd pojawia się dla całego okresu, czy dla konkretnego miesiąca?', createdAt: daysFromNow(-1), mine: true },
  ],
  'tic-2': [
    { id: 'msg-2-1', authorType: 'user', authorId: 'usr-1', authorName: 'Jan Kowalski', body: 'Ile faktur mogę wystawić w planie Pro?', createdAt: daysFromNow(-5), mine: false },
    { id: 'msg-2-2', authorType: 'support', authorId: 'master-admin-1', authorName: 'Wsparcie Księgowskaz', body: 'Plan Pro nie ma limitu faktur. Limit dotyczy wyłącznie planu Darmowego (5 faktur miesięcznie).', createdAt: daysFromNow(-4), mine: true },
    { id: 'msg-2-3', authorType: 'user', authorId: 'usr-1', authorName: 'Jan Kowalski', body: 'Dziękuję, sprawdzę ustawienia planu.', createdAt: daysFromNow(-3), mine: false },
  ],
  'tic-3': [
    { id: 'msg-3-1', authorType: 'user', authorId: 'usr-4', authorName: 'Maria Wiśniewska', body: 'Nie mogę dodać nowego pracownika, formularz się nie zapisuje.', createdAt: daysFromNow(-6), mine: false },
    { id: 'msg-3-2', authorType: 'support', authorId: 'master-admin-1', authorName: 'Wsparcie Księgowskaz', body: 'Prosimy o zrzut ekranu z komunikatem błędu, który się pojawia.', createdAt: daysFromNow(-4), mine: true },
  ],
  'tic-4': [
    { id: 'msg-4-1', authorType: 'user', authorId: 'usr-3', authorName: 'Piotr Lewandowski', body: 'Proszę o zmianę adresu na fakturze FV/2026/07/12.', createdAt: daysFromNow(-10), mine: false },
    { id: 'msg-4-2', authorType: 'support', authorId: 'master-admin-1', authorName: 'Wsparcie Księgowskaz', body: 'Dane zostały zaktualizowane, dziękujemy.', createdAt: daysFromNow(-8), mine: true },
  ],
  'tic-5': [
    { id: 'msg-5-1', authorType: 'user', authorId: 'usr-2', authorName: 'Anna Nowak', body: 'Czy rozliczenie VAT-7 za czerwiec zostało już wysłane?', createdAt: daysFromNow(-24), mine: false },
    { id: 'msg-5-2', authorType: 'support', authorId: 'master-admin-1', authorName: 'Wsparcie Księgowskaz', body: 'Tak, deklaracja została wysłana i przyjęta. Sprawa zamknięta.', createdAt: daysFromNow(-20), mine: true },
  ],
  'tic-6': [
    { id: 'msg-6-1', authorType: 'user', authorId: 'usr-5', authorName: 'Krzysztof Dąbrowski', body: 'Gdzie znajdę deklarację PIT-11 w panelu Kadry?', createdAt: daysFromNow(-1), mine: false },
  ],
};

export function mockTicketDetail(id: string): Record<string, unknown> {
  const summary = mockSupportTickets.data.find((t) => t.id === id) ?? mockSupportTickets.data[0];
  return {
    id: summary.id,
    panel: summary.panel,
    companyId: summary.companyId,
    companyName: summary.companyName,
    createdById: summary.createdById,
    createdByName: summary.createdByName,
    subject: summary.subject,
    category: summary.category,
    status: summary.status,
    createdAt: summary.createdAt,
    updatedAt: summary.updatedAt,
    messages: ticketThreads[summary.id] ?? [],
  };
}

const subscriptions: Record<string, Record<string, unknown>> = {
  'tenant-1': { companyId: 'tenant-1', planId: 'pro', planName: 'Pro', status: 'active', dueDate: unixDaysFromNow(18), periodMonths: 1, autoRenew: true, suspendedManually: false, defaultMethodId: 'pm-visa-4242' },
  'tenant-2': { companyId: 'tenant-2', planId: 'max', planName: 'Max', status: 'past_due', dueDate: unixDaysFromNow(-5), periodMonths: 12, autoRenew: true, suspendedManually: false, defaultMethodId: 'pm-mc-5100' },
  'tenant-3': { companyId: 'tenant-3', planId: 'free', planName: 'Darmowy', status: 'demo', dueDate: 0, periodMonths: 0, autoRenew: false, suspendedManually: false, defaultMethodId: '' },
  'tenant-4': { companyId: 'tenant-4', planId: 'pro', planName: 'Pro', status: 'suspended', dueDate: unixDaysFromNow(-40), periodMonths: 1, autoRenew: false, suspendedManually: true, defaultMethodId: 'pm-visa-1881' },
  'tenant-5': { companyId: 'tenant-5', planId: 'max', planName: 'Max', status: 'active', dueDate: unixDaysFromNow(60), periodMonths: 12, autoRenew: true, suspendedManually: false, defaultMethodId: 'pm-visa-7788' },
};

export function mockSubscription(id: string): Record<string, unknown> {
  return (
    subscriptions[id] ?? {
      companyId: id,
      planId: '',
      planName: '',
      status: 'none',
      dueDate: 0,
      periodMonths: 0,
      autoRenew: false,
      suspendedManually: false,
      defaultMethodId: '',
    }
  );
}

// Kontrakt GET /master/default-invoice-template — dokładnie to, co czyta edytor
// szablonu (name / presetId / fontId / colors), w barwach presetu „classic".
export const mockDefaultTemplate = {
  name: 'Domyślny szablon faktury',
  presetId: 'classic',
  fontId: 'inter',
  colors: { primary: '#1D4A3A', secondary: '#E5EEE9', text: '#10231B', headerText: '#F4F6F3' },
};

export function mockKeycloakToken(): Record<string, unknown> {
  const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = btoa(
    JSON.stringify({
      sub: 'master-admin-1',
      email: 'admin@ksiegowskaz.pl',
      preferred_username: 'admin@ksiegowskaz.pl',
      given_name: 'Master',
      realm_access: { roles: ['master-admin'] },
      exp: Math.floor(Date.now() / 1000) + 3600,
    }),
  );
  return {
    access_token: `${header}.${payload}.mock-signature`,
    refresh_token: 'mock-refresh-token',
    token_type: 'Bearer',
    expires_in: 1800,
    refresh_expires_in: 3600,
    scope: 'openid',
  };
}

export const mockPromoCodes = {
  data: [
    { id: 'promo-1', value: 'START2026', discountPct: 20, active: true, usageCount: 14, validUntil: '2026-12-31', createdAt: daysFromNow(-60) },
    { id: 'promo-2', value: 'BIURO50', discountAmount: 50, currency: 'PLN', nip: '5260001246', active: true, usageCount: 3, createdAt: daysFromNow(-20) },
    { id: 'promo-3', value: 'LATO2025', discountPct: 15, active: false, usageCount: 41, validUntil: '2025-09-30', createdAt: daysFromNow(-400) },
  ],
};

export const mockPayments = {
  data: [
    { orderId: 'ord-1', companyId: 'tenant-1', companyName: 'Przykładowa Firma sp. z o.o.', planName: 'Pro', amount: 39.99, discountAmount: 10, currency: 'PLN', status: 'completed', payuOrderId: 'PAYU-9K2LX', promoCode: 'START2026', periodMonths: 1, createdAt: daysFromNow(-3), paidAt: daysFromNow(-3) },
    { orderId: 'ord-2', companyId: 'tenant-2', companyName: 'Beta Handel sp.j.', planName: 'Max', amount: 990.0, currency: 'PLN', status: 'completed', payuOrderId: 'PAYU-7Q1MB', periodMonths: 12, createdAt: daysFromNow(-11), paidAt: daysFromNow(-11) },
    { orderId: 'ord-3', companyId: 'tenant-4', companyName: 'Delta Logistyka sp. z o.o.', planName: 'Pro', amount: 49.99, currency: 'PLN', status: 'failed', payuOrderId: 'PAYU-3F8TT', periodMonths: 1, createdAt: daysFromNow(-5) },
    { orderId: 'ord-4', companyId: 'tenant-5', companyName: 'Omega Nieruchomości S.A.', planName: 'Max', amount: 99.0, currency: 'PLN', status: 'pending', payuOrderId: 'PAYU-1A0PZ', periodMonths: 1, createdAt: daysFromNow(-1) },
  ],
  total: 4,
  totalAmount: 1178.98,
};

export const mockPlatformStats = {
  companies: 5,
  companiesThisMonth: 1,
  users: 6,
  usersThisMonth: 1,
  accountants: 3,
  hrStaff: 2,
  subscriptionsByStatus: [
    { label: 'active', count: 3 },
    { label: 'demo', count: 1 },
    { label: 'suspended', count: 1 },
  ],
  companiesByPlan: [
    { label: 'Pro', count: 2 },
    { label: 'Max', count: 2 },
    { label: 'Free', count: 1 },
  ],
  revenueThisMonth: 1178.98,
  revenueLastMonth: 890.5,
  revenueTotal: 18420.35,
  paymentsCompleted: 2,
  paymentsFailed: 1,
  revenueByMonth: [
    { month: '2026-03', amount: 640.0 },
    { month: '2026-04', amount: 720.5 },
    { month: '2026-05', amount: 980.0 },
    { month: '2026-06', amount: 1120.0 },
    { month: '2026-07', amount: 890.5 },
    { month: '2026-08', amount: 1178.98 },
  ],
};

export const mockPlatformSettings = {
  supportEmail: 'wsparcie@ksiegowskaz.pl',
  contactEmail: 'kontakt@ksiegowskaz.pl',
  registrationOpen: true,
  maintenanceMessage: '',
};

export const mockWhatsNew = {
  data: [
    {
      id: 'wn-1',
      publishedAt: '2026-08-10',
      active: true,
      content: {
        pl: { title: 'Proformy i rachunki', body: 'W module Faktury pojawiły się zakładki Proformy i Rachunki. Pro formę przekształcisz w fakturę jednym kliknięciem.' },
        en: { title: 'Pro forma and bills', body: 'The Invoices module now has Pro forma and Bills tabs. A pro forma converts to an invoice in one click.' },
      },
    },
    {
      id: 'wn-2',
      publishedAt: '2026-07-02',
      active: false,
      content: {
        pl: { title: 'Przypomnienia o należnościach', body: 'Dostaniesz powiadomienie na trzy dni przed terminem płatności i w dniu, w którym faktura stanie się przeterminowana.' },
      },
    },
  ],
};
